import Vue from 'vue'
import VueI18n from 'vue-i18n' // 引入 Vue I18n
import tc from './tc.json' // 存放中文語系檔
import en from './en.json' // 存放英文語系檔
import store from '../store'

Vue.use(VueI18n)

let locale = 'en'

// 檢查 localStorage 是否已有保存使用者選用的語系資訊
if (localStorage.getItem('lang-mark')) {
	locale = localStorage.getItem('lang-mark');
	store.commit('setLang', locale);
} else {
	store.commit('setLang', locale);
}

const i18n = new VueI18n({
	locale: locale,
	messages: {
		'tc': tc,
		'en': en
	}
})

export default i18n